<!-- View Masters Listing -->
<div class="card">
        <!--begin::Card header-->
        <div class="card-header border-0 pt-6">
          <!--begin::Card title-->
          <div class="card-title">
            <!--begin::Search-->
            <div class="d-flex align-items-center position-relative my-1">
              <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              <input type="text"
                     [(ngModel)]="searchTerm"
                     (keyup.enter)="onSearch()"
                     class="form-control form-control-solid w-250px ps-13"
                     placeholder="Search View Masters" />
            </div>
            <!--end::Search-->
          </div>
          <!--end::Card title-->
          <!--begin::Card toolbar-->
          <div class="card-toolbar">
            <!--begin::Toolbar-->
            <div class="d-flex justify-content-end" data-kt-view-master-table-toolbar="base">
              <!--begin::Add View Master-->
              <button type="button" class="btn btn-sm fw-bold btn-primary me-3" (click)="openAddViewMasterModal()">
                <i class="ki-duotone ki-plus fs-2"></i>Add View Master
              </button>
              <!--end::Add View Master-->
              <!--begin::Filter-->
              <button type="button" class="btn btn-light-primary me-3 btn-sm" (click)="toggleFilters()">
                <i class="ki-duotone ki-filter fs-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>Filter
              </button>
              <!--end::Filter-->
              <!--begin::Search-->
              <button type="button" class="btn btn-primary btn-sm" (click)="onSearch()">
                <i class="ki-duotone ki-magnifier fs-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>Search
              </button>
              <!--end::Search-->
            </div>
            <!--end::Toolbar-->
          </div>
          <!--end::Card toolbar-->
        </div>
        <!--end::Card header-->

        <!--begin::Filters-->
        <div class="card-body border-top pt-6" [class.d-none]="!showFiltersForm">
          <div class="row mb-6">
            <div class="col-md-4">
              <label class="form-label">Date From</label>
              <input type="date"
                     [(ngModel)]="filters.date_from"
                     class="form-control form-control-solid" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Date To</label>
              <input type="date"
                     [(ngModel)]="filters.date_to"
                     class="form-control form-control-solid" />
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <button type="button" class="btn btn-primary me-2 btn-sm" (click)="applyFilters()">Apply</button>
              <button type="button" class="btn btn-light btn-sm" (click)="resetFilters()">Reset</button>
            </div>
          </div>
        </div>
        <!--end::Filters-->

        <!--begin::Card body-->
        <div class="card-body py-4">
          <!--begin::Loading-->
          <div *ngIf="isLoading" class="d-flex justify-content-center py-10">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <!--end::Loading-->

          <!--begin::Table-->
          <div *ngIf="!isLoading" class="table-responsive">
            <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_view_masters_table">
              <!--begin::Table head-->
              <thead>
                <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                  <th class="min-w-150px">Name</th>
                  <th style="width: 300px; max-width: 300px;">Vehicle Fields</th>
                  <th style="width: 300px; max-width: 300px;">Charges</th>
                  <th class="min-w-125px">Created Date</th>
                  <th class="text-end min-w-100px">Actions</th>
                </tr>
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody class="text-gray-600 fw-semibold">
                <tr *ngFor="let viewMaster of viewMasters; trackBy: trackByFn">
                  <td class="ps-2">
                    <div class="d-flex align-items-center">
                      <div class="d-flex justify-content-start flex-column">
                        <span class="text-dark fw-bold text-hover-primary fs-6">{{ viewMaster.name || 'N/A' }}</span>
                      </div>
                    </div>
                  </td>
                  <td style="width: 300px; max-width: 300px; word-wrap: break-word; white-space: normal;">
                    <div class="text-gray-800 fs-6" style="line-height: 1.4;">
                      {{ getVehicleFieldsDisplay(viewMaster.vehicle_fields) }}
                    </div>
                  </td>
                  <td style="width: 300px; max-width: 300px; word-wrap: break-word; white-space: normal;">
                    <div class="text-gray-800 fs-6" style="line-height: 1.4;">
                      {{ getChargesDisplay(viewMaster.charges) }}
                    </div>
                  </td>
                  <td>
                    <span class="text-gray-600">{{ (viewMaster.created_at | date:'short') || 'N/A' }}</span>
                  </td>
                  <td class="text-end">
                    <div class="d-flex justify-content-end gap-2">
                      <!--begin::Edit-->
                      <button type="button"
                              class="btn btn-sm btn-icon btn-light-primary"
                              (click)="openEditViewMasterModal(viewMaster)"
                              title="Edit View Master">
                        <i class="ki-duotone ki-pencil fs-5">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </i>
                      </button>
                      <!--end::Edit-->
                      <!--begin::Delete-->
                      <button type="button"
                              class="btn btn-sm btn-icon btn-light-danger"
                              (click)="deleteViewMaster(viewMaster)"
                              title="Delete View Master">
                        <i class="ki-duotone ki-trash fs-5">
                          <span class="path1"></span>
                          <span class="path2"></span>
                          <span class="path3"></span>
                          <span class="path4"></span>
                          <span class="path5"></span>
                        </i>
                      </button>
                      <!--end::Delete-->
                    </div>
                  </td>
                </tr>
                <!--begin::No data row-->
                <tr *ngIf="viewMasters.length === 0">
                  <td colspan="5" class="text-center py-10">
                    <div class="d-flex flex-column align-items-center">
                      <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-4">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </i>
                      <span class="text-muted fs-6">No view masters found</span>
                    </div>
                  </td>
                </tr>
                <!--end::No data row-->
              </tbody>
              <!--end::Table body-->
            </table>
          </div>
          <!--end::Table-->

          <!-- Pagination -->
          <div *ngIf="!isLoading && viewMasters.length > 0">
            <app-pagination
              [paginationInfo]="paginationInfo"
              [loading]="isLoading"
              (pageChange)="onPageChange($event)">
            </app-pagination>
          </div>
        </div>
        <!--end::Card body-->
      </div>
      <!--end::Card-->

<!-- View Master Add/Edit Modal -->
<app-md-add-master
  (viewMasterAdded)="onViewMasterAdded()"
  (viewMasterUpdated)="onViewMasterUpdated()">
</app-md-add-master>
